import { css } from '@emotion/react'
import { Checkbox, DropdownDivider, DropdownItem, Flow, Icon, Text, Theme, useTheme } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import { Ellipsis } from 'components/Ellipsis'

import { MAPA_SIDEBAR_NAV_ITEMS, MapaSidebarNavItemEnum, TerritorioCamadaQueryModel } from '../../model-territorioMapa'

interface CamadasListItemProps {
  camada: TerritorioCamadaQueryModel
  onDelete: () => void
}

export function CamadasListItem(props: Readonly<CamadasListItemProps>) {
  const { camada, onDelete } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Flow direction='horizontal' alignItems='center' gap={0.5} style={styles.root}>
      <Checkbox style={styles.checkbox} />
      <Flow direction='vertical' gap={0}>
        <Flow direction='horizontal' gap={0.25} alignItems='center'>
          <Icon icon={MAPA_SIDEBAR_NAV_ITEMS[MapaSidebarNavItemEnum.CAMADAS].icon} fill='primary' size={1.25} />
          <Ellipsis maxLines={1}>
            <Text fontWeight='bold'>{camada.nome}</Text>
          </Ellipsis>
        </Flow>
        <Ellipsis maxLines={2}>
          <Text style={styles.description}>{camada.descricao}</Text>
        </Ellipsis>
      </Flow>
      <DropdownButton size='small'>
        <DropdownItem>Ver detalhes</DropdownItem>
        <DropdownDivider />
        <DropdownItem type='danger' onClick={onDelete}>
          <Flow direction='horizontal' alignItems='center' gap={0.5}>
            <Icon icon='trashOutline' />
            Excluir
          </Flow>
        </DropdownItem>
      </DropdownButton>
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    grid-template-columns: 1.5rem 1fr 2rem;
  `,
  checkbox: css`
    margin-left: -0.25rem;
  `,
  description: css`
    color: ${theme.pallete.gray.c40};
  `,
})
